module.exports = __webpack_public_path__ + "img/icon-spicy.37a8142b.svg";